var _defs, _rect, _rect2, _rect3, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _path, _polygon6, _rect4, _rect5, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _path2, _polygon12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlugRetainers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2eabe2;}.cls-2{fill:#414042;}.cls-3{fill:#a7a9ac;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39.41,
    y: 43.81,
    width: 21.18,
    height: 14.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.41,
    y: 63.14,
    width: 21.18,
    height: 3.71
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.41,
    y: 77.46,
    width: 21.18,
    height: 4.9
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "59.35 63.14 40.65 63.14 39.41 57.91 60.59 57.91 59.35 63.14"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "59.35 70.01 40.65 70.01 39.41 66.85 60.59 66.85 59.35 70.01"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "59.35 70.01 40.65 70.01 39.41 71.94 60.59 71.94 59.35 70.01"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "59.35 71.94 40.65 71.94 39.41 73.87 60.59 73.87 59.35 71.94"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "59.35 73.87 40.65 73.87 39.41 75.79 60.59 75.79 59.35 73.87"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M59.35,75.79H40.65l-1.24,1.93a61,61,0,0,0,21.18,0Z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "39.41 82.36 42.54 89.1 48.01 89.1 48.01 86.83 51.99 86.83 51.99 89.1 57.46 89.1 60.59 82.36 39.41 82.36"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.41,
    y: 34.87,
    width: 21.18,
    height: 3.71,
    transform: "translate(100 73.45) rotate(180)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.41,
    y: 19.36,
    width: 21.18,
    height: 4.78,
    transform: "translate(100 43.49) rotate(180)"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "40.65 38.58 59.35 38.58 60.59 43.81 39.41 43.81 40.65 38.58"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "40.65 31.7 59.35 31.7 60.59 34.87 39.41 34.87 40.65 31.7"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "40.65 31.7 59.35 31.7 60.59 29.78 39.41 29.78 40.65 31.7"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "40.65 29.78 59.35 29.78 60.59 27.85 39.41 27.85 40.65 29.78"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "40.65 27.85 59.35 27.85 60.59 25.93 39.41 25.93 40.65 27.85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.65,25.93h18.7L60.59,24a61,61,0,0,0-21.18,0Z"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "57.46 12.62 51.99 12.62 51.99 10.9 48.01 10.9 48.01 12.62 42.54 12.62 39.41 19.36 60.59 19.36 57.46 12.62"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugRetainers);
export default __webpack_public_path__ + "static/media/PlugRetainers.b77eac9c8557c7b6835110c63dee8dca.svg";
export { ForwardRef as ReactComponent };